import type {
  TAck,
  TSocketAuth,
  TSocketAuthProvider,
  TSocketIoAuth,
} from './socket.types.ts';
import { isRecord } from '#utils/object/index.ts';

const finalDisconnects = new Set([
  'io client disconnect',
  'io server disconnect',
]);

export const willReconnect = (reason: string): boolean =>
  !finalDisconnects.has(reason);

export const toSocketAuth = (
  auth: TSocketAuth | TSocketAuthProvider | undefined,
): TSocketIoAuth | undefined => {
  if (typeof auth !== 'function') {
    return auth;
  }

  return (callback) => {
    Promise.resolve(auth()).then((value) => callback(value));
  };
};

export const isAck = (value: unknown): value is TAck =>
  isRecord(value) && typeof value.ok === 'boolean';
